import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatchResult, UrlSegment, withViewTransitions } from '@angular/router';
import { HomeFiveComponent } from './components/pages/home-five/home-five.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { About } from './components/pages/about/about.component';
import { Services } from './components/pages/services/services.component';
import { QuizComponent } from './components/pages/quiz/quiz.component';
import { QuizListComponent } from './components/pages/quiz-list/quiz-list.component';
import { QuizResultsComponent } from './components/pages/quiz-results/quiz-results.component';

/** Matches a leading language segment (am|en|ru) only, so unknown paths reach the 404 page. */
export function langMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  return segments.length && /^(am|en|ru)$/.test(segments[0].path)
    ? { consumed: [segments[0]], posParams: { lang: segments[0] } }
    : null;
}

/** The theory test is a focused exam UI: native scrolling, no smooth-scroll layer. */
const noSmooth = { smoothScroll: false };

const routes: Routes = [
  { path: '', component: HomeFiveComponent },
  // The 2022 tests were removed: their old list and test URLs open the 2026 ABC list.
  { path: 'quiz', redirectTo: 'quiz/v2/abc', pathMatch: 'full' },
  { path: 'quiz/:id', redirectTo: 'quiz/v2/abc', pathMatch: 'full' },
  // 2026 edition: one question bank per licence category (abc, dt).
  { path: 'quiz/v2/:category', component: QuizListComponent, data: noSmooth },
  { path: 'quiz/v2/:category/:id', component: QuizComponent, data: noSmooth },
  { path: 'home', component: HomeFiveComponent },
  { path: 'services', component: Services },
  { path: 'about', component: About },
  { path: 'quiz-results', component: QuizResultsComponent, data: noSmooth },

  {
    matcher: langMatcher,
    children: [
      { path: '', component: HomeFiveComponent },
      { path: 'about', component: About },
      { path: 'services', component: Services },
      { path: 'quiz', redirectTo: 'quiz/v2/abc', pathMatch: 'full' },
      { path: 'quiz/:id', redirectTo: 'quiz/v2/abc', pathMatch: 'full' },
      { path: 'quiz/v2/:category', component: QuizListComponent, data: noSmooth },
      { path: 'quiz/v2/:category/:id', component: QuizComponent, data: noSmooth },
      { path: 'quiz-results', component: QuizResultsComponent, data: noSmooth },
    ],
  },

  { path: '**', component: ErrorComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  // View transitions between routes. These are the providers `enableViewTransitions: true` adds,
  // plus skipInitialTransition: the first navigation has nothing to transition from, and wrapping
  // it changes change-detection timing while translations are still loading (NG0100 on a fresh
  // load of an unprefixed URL when another language is stored).
  providers: [withViewTransitions({ skipInitialTransition: true }).ɵproviders],
})
export class AppRoutingModule {}
